import React from "react";
import { Modal } from "flowbite-react";

const CommonModal = ({
  modalSize = "sm",
  headerTitle,
  children, // Accepting children as a prop
  onClose,
  show = false,
  overflow = false,
  dismissible = true // Allow closing on backdrop click by default
}) => {
  
  return (
    <Modal 
      size={modalSize} 
      show={show} 
      onClose={onClose}
      dismissible={dismissible}
    >
      <Modal.Header className="border-none p-4 pb-0">
        <span className="text-theme text-xl font-medium">{headerTitle}</span>
      </Modal.Header>
      <Modal.Body className={`p-4 ${overflow ? "md:overflow-visible" : ""}`}>{children}</Modal.Body>
    </Modal>
  );
};

export default CommonModal;
